import { gsap } from 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/+esm';
import { ScrollTrigger } from 'https://cdn.jsdelivr.net/npm/gsap@3.13/ScrollTrigger.js';
import { ScrollSmoother } from 'https://cdn.jsdelivr.net/npm/gsap@3.13/ScrollSmoother.js';
import { SplitText } from "https://cdn.jsdelivr.net/npm/gsap@3.13/SplitText.min.js";
import Lenis from 'https://cdn.jsdelivr.net/npm/lenis@1.3.8/+esm';

import { SmoothMarquee } from './marquee.js';
import MECAnimations from './mec-animations.js';
import { MotionLab } from './motion.js';

/**
 * Number prototype extension for clamping values
 */
Number.prototype.clamp = function (min, max) {
  return Math.min(Math.max(this, min), max);
};

// Global MEC Animations instance
let mecAnimations = null;
let motionLab = null;

window.addEventListener('DOMContentLoaded', async (event) => {
  // Early returns for admin and reduced motion
  if (document.body.classList.contains('wp-admin') || !document.body.classList.contains('home')) {
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  if (window.location.pathname !== "/") {
    return;
  } else {
    window.scrollTo(0, 0); // Ensure top of page on load
  }

  // Prevent multiple initializations
  if (window.__gsapInitialized) return;
  window.__gsapInitialized = true;

  // console.log("DOM loaded - initializing MEC Animations");

  try {
    if (document.fonts) {
      await document.fonts.ready;
      // console.log("Fonts loaded, initializing animations");
    } else {
      // Fallback delay for older browsers
      await new Promise(resolve => setTimeout(resolve, 500));
    }
  } catch (error) {
    // console.warn("Font loading failed, proceeding anyway:", error);
  }

  // Initialize MEC Animations
  mecAnimations = new MECAnimations({
    gsap,
    ScrollTrigger,
    ScrollSmoother,
    SplitText,
    Lenis
  });

  motionLab = new MotionLab();

  // Initialize marquee if element exists
  const marqueeElement = document.getElementById('myMarquee');
  if (marqueeElement) {
    const marquee = new SmoothMarquee(marqueeElement, {
      baseSpeed: 40,
      maxMultiplier: 3,
      gap: 42,
      direction: 1,
      clampVelTo: 2000,
    });
    marquee.start();
  }

  // Initialize animations
  mecAnimations.init();
  motionLab.init();

  // Cleanup on page unload (WordPress specific)
  window.addEventListener('beforeunload', () => {
    if (mecAnimations) {
      mecAnimations.destroy();
    }
  });

  // Resize event listener for animations
  window.addEventListener("resize", () => {
    if (mecAnimations) {
      // mecAnimations.resize();
    }
  });
});